export const websiteInfo = {
    name: 'Зооландия',
    company: 'Ветеринарна клиника',
    logo: 'zoolandia-logo.svg'
}

export const facebookPageInfo = {
    url: 'https://www.facebook.com/zoolandiabg',
    title: 'Фейсбук страница на Зооландия'
}

export const navItems = [
    {
        link: '#about',
        title: 'За нас'
    },
    {
        link: '#services',
        title: 'Услуги'
    },
    {
        link: '#subscription',
        title: 'Абонамент'
    },
    {
        link: '#contact',
        title: 'Контакти'
    }
]

export const webmaster = {
    text: 'Уеб дизайн и програмиране',
    url: 'https://www.yweb.dev',
    name: 'yweb.dev',
    logo: 'yweb-dev-logo-sm.svg'
}

export const priceNavItems = {
    reviews:'Прегледи',
    vaccines:'Ваксини',
    deworm:'Обезпаразитяване',
    hospitalization:'Хоспитализация',
    procedures:'Мед. процедури',
    surgery:'Хирургия',
    dentistry:'Стоматология',
    diagnosis:'Диагностика',
    others:'Други'
}
